<div class="fw-TertiaryNavigation thirdLevelNav" *ngIf="layout=='vertical'">
    <ul class="fw-TertiaryNavigation_List layouts level-1">
        <ng-container *ngFor="let fourthLevel of fourthNavLinks">
            <li  [class.open]="selectedFourthPageId == fourthLevel.id" >
                <span class="open" *ngIf="fourthLevel.istitle=='true'; else noTitle">{{ fourthLevel.name | pershingTranslate}}</span>
                <ng-template #noTitle>
                    <a id="nav-{{fourthLevel.id}}" href="javascript:void(0);" (click)="handleFourthLevelNavigation(fourthLevel)" class="">{{ fourthLevel.name | pershingTranslate}}</a>
                </ng-template>
            </li>
        </ng-container>
    </ul>
</div>
<div class="fw-TertiaryNavigation nav-f2 nav-menu nav-f2-desktop" *ngIf="layout=='horizontal'">
    <ul class="fw-TertiaryNavigation_List layouts level-1">
        <ng-container *ngFor="let fourthLevel of fourthNavLinks">            
            <li [class.selected]="selectedFourthPageId == fourthLevel.id">
                <a href="javascript:void(0);" (click)="handleFourthLevelNavigation(fourthLevel)">{{ fourthLevel.name | pershingTranslate}}</a>
            </li>            
         </ng-container>
    </ul>
</div>


